import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';

import { UserContext } from '~/dashboard/context';
import apiCalls from '~/helpers/apiCalls';


type UseThresholdSimulatorParamsOptions = {
  publicId: string;
  workflowVersion: number;
  enabled?: boolean;
};

function getQueryKey(
  { publicId, workflowVersion }: UseThresholdSimulatorParamsOptions,
) {
  return ['threshold-simulator', 'params', publicId, workflowVersion];
}

function useThresholdSimulatorParams(options: UseThresholdSimulatorParamsOptions) {
  const { typhonDomain } = useContext(UserContext);
  const {
    publicId,
    workflowVersion,
    enabled = true,
  } = options;

  return useQuery({
    enabled: enabled && Boolean(publicId && workflowVersion),
    queryKey: getQueryKey(options),
    queryFn: () => apiCalls.workflows.thresholdSimulator.getParams({
      typhonDomain,
      publicId,
      workflowVersion,
    }),
    retry: 1,
  });
}

useThresholdSimulatorParams.getQueryKey = getQueryKey;
export default useThresholdSimulatorParams;
